import classNames from 'classnames';
import { motion } from 'motion/react';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import LogoSVG from './SVG/LogoSVG.component';

const AccountableLogoWithSlugan: FC<{
  animate?: boolean;
  size?: 'small' | 'large';
}> = ({ animate, size = 'large' }) => {
  const { t } = useTranslation();

  return (
    <>
      <div
        className={classNames('w-[16rem] flex justify-center', {
          'w-[12.5rem]': size === 'small',
        })}
      >
        <motion.div
          initial={
            animate
              ? {
                  position: 'relative',
                  top: '150px',
                  scale: 1.6,
                }
              : { top: 0, scale: 1 }
          }
          animate={{ top: 0, scale: 1 }}
          transition={{ duration: 0.2, delay: 0.5 }}
        >
          <LogoSVG className="w-full h-full" />
        </motion.div>
      </div>

      <motion.span
        initial={
          animate
            ? {
                position: 'relative',
                opacity: 0,
              }
            : { opacity: 1 }
        }
        animate={{ opacity: 1 }}
        transition={{ duration: 0.2, delay: 0.8 }}
        className={classNames(
          'block text-taxes-950 font-degular font-bold text-3xl',
          {
            '!text-2xl': size === 'small',
          },
        )}
      >
        {t('slogan')}
      </motion.span>
    </>
  );
};

export default AccountableLogoWithSlugan;
